import publicRequest from '../configs/axios';
import { API_ENDPOINTS } from '../configs/api.config';

/**
 * Users Service
 * Handles all user-related API calls
 * Uses configured axios instance with auth token interceptor
 */

class UsersService {
  /**
   * Get current user profile
   * @returns {Promise}
   */
  async getCurrentUser() {
    try {
      const response = await publicRequest.get(API_ENDPOINTS.AUTH.ME);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Update user profile
   * @param {string} userId - User ID
   * @param {Object} userData - User data to update
   * @returns {Promise}
   */
  async updateUser(userId, userData) {
    try {
      const response = await publicRequest.put(
        `${API_ENDPOINTS.USERS}/${userId}`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Update user password
   * @param {string} userId - User ID
   * @param {Object} passwordData - Password data
   * @returns {Promise}
   */
  async updatePassword(userId, passwordData) {
    try {
      const response = await publicRequest.put(
        `${API_ENDPOINTS.USERS}/${userId}/password`,
        passwordData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
}

export default new UsersService();
